<template>
    <div class="lottery">
        <h2>{{ lottery.name }}</h2>
        <dl>
            <dt v-text="lottery.name || 'Sequenz ' + (index + 1)"></dt>
            <dd class="sequence">
                <input v-for="number in sequence" type="number" :value="number" min="0" max="9">
            </dd>
        </dl>
        <my-button v-on:click="generateSequence">Zufallszahlen generieren</my-button>
    </div>
</template>

<script>
//    import { shuffle } from '../utils/helpers';
    import MyButton from '@/components/Button';

    export default {
        name: 'sequence',
        props: {
            lottery: {
                type: Object
            }
        },
        components: {
            MyButton
        },
        data () {
            return {
                sequence: []
            }
        },
        methods: {
            generateSequence () {
                let seq = [];
                Array.from(Array(this.lottery.length)).forEach(() => {
                    seq.push(Math.floor((Math.random() * 9)));
                });
                this.sequence = seq;
            }
        }
    }
</script>

<style scoped lang="scss">
    .lottery {
        margin-bottom: 2rem;
    }

    h2 {
        margin-bottom: 1rem;
    }

    dt {
        line-height: 2em;
    }

    .sequence {
        margin: 0;
    }
    input {
        box-sizing: border-box;
        height: 2em;
        width: 3em;
        padding-left: 1.15em;
        border: 1px solid #ccc;
        line-height: 2em;
        margin: 0 0.2em 0.2em 0;
        font-size: inherit;
    }
</style>



// WEBPACK FOOTER //
// Sequence.vue?1b302988